import React from 'react';
import { Star, ArrowRight, Eye, Users, TrendingUp } from 'lucide-react';
import './AnalyticsModule.css';

const AnalyticsModule = () => {
    return (
        <section id="analytics-module" className="container" style={{ padding: '6rem 2rem' }}>
            <div className="featured-card">

                {/* Header */}
                <div className="featured-header">
                    <span className="featured-badge">
                        <Star size={14} className="badge-icon" />
                        ANALYTICS MODULE
                    </span>
                    <h2 className="featured-title">Loss Analysis: Maximise Productivity</h2>
                </div>

                {/* Main Content Split */}
                <div className="featured-content">

                    {/* Left: Key Features */}
                    <div className="capabilities-section">
                        <h3 className="capabilities-title">Key Features</h3>

                        <div className="capability-item">
                            <ArrowRight className="capability-icon" />
                            <div>
                                <h4 className="capability-name">Six Big Loss Framework</h4>
                                <p className="capability-desc">Industry-standard categorisation framework</p>
                            </div>
                        </div>

                        <div className="capability-item">
                            <ArrowRight className="capability-icon" />
                            <div>
                                <h4 className="capability-name">Automated Data Collection</h4>
                                <p className="capability-desc">Direct collection from connected machines</p>
                            </div>
                        </div>

                        <div className="capability-item">
                            <ArrowRight className="capability-icon" />
                            <div>
                                <h4 className="capability-name">Pareto Analysis</h4>
                                <p className="capability-desc">Instant prioritisation of major losses</p>
                            </div>
                        </div>

                        <div className="capability-item">
                            <ArrowRight className="capability-icon" />
                            <div>
                                <h4 className="capability-name">Custom Report Generation</h4>
                                <p className="capability-desc">Tailored insights for any date range</p>
                            </div>
                        </div>

                        <div className="capability-item">
                            <ArrowRight className="capability-icon" />
                            <div>
                                <h4 className="capability-name">Action Plan Tracking</h4>
                                <p className="capability-desc">Monitor closure of corrective measures</p>
                            </div>
                        </div>
                    </div>

                    {/* Right: Dashboard Image Reverse */}
                    <div className="dashboard-preview-container">
                        <img
                            src="./assets/modules/analytics.jpg"
                            alt="Loss Analysis Dashboard"
                            className="dashboard-preview-img"
                            style={{ objectFit: 'cover' }}
                        />
                    </div>
                </div>
            </div>

            {/* Split Bottom Section for Impacts */}
            <div className="featured-card martop1">
                <div className="featured-stats-section">
                    <h3 className="stats-title" style={{ marginBottom: '2rem' }}>Business Impact</h3>

                    <div className="impact-grid">

                        {/* Impact 1 */}
                        <div className="impact-card">
                            <div className="impact-icon-wrapper">
                                <Eye className="impact-icon" size={28} />
                            </div>
                            <h4 className="impact-title">Visibility</h4>
                            <p className="impact-desc">Transparent loss identification across all shifts</p>
                        </div>

                        {/* Impact 2 */}
                        <div className="impact-card">
                            <div className="impact-icon-wrapper">
                                <Users className="impact-icon" size={28} />
                            </div>
                            <h4 className="impact-title">Accountability</h4>
                            <p className="impact-desc">Clear ownership of improvement actions</p>
                        </div>

                        {/* Impact 3 */}
                        <div className="impact-card">
                            <div className="impact-icon-wrapper">
                                <TrendingUp className="impact-icon" size={28} />
                            </div>
                            <h4 className="impact-title">ROI</h4>
                            <p className="impact-desc">Quantifiable savings from waste elimination</p>
                        </div>

                    </div>
                </div>
            </div>

        </section>
    );
};

export default AnalyticsModule;
